import React from 'react';
import { FaCommentDots, FaChartLine, FaMedal } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Reveal } from './motion/Reveal';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: 1,
      title: t('howItWorks.steps.0.title'),
      description: t('howItWorks.steps.0.description'),
      icon: <FaCommentDots />
    },
    {
      number: 2,
      title: t('howItWorks.steps.1.title'),
      description: t('howItWorks.steps.1.description'),
      icon: <FaChartLine />
    },
    {
      number: 3,
      title: t('howItWorks.steps.2.title'),
      description: t('howItWorks.steps.2.description'),
      icon: <FaMedal />
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <Reveal>
          <h2 className="section-title">{t('howItWorks.title')}</h2>
          <p className="section-subtitle">{t('howItWorks.subtitle')}</p>
        </Reveal>
        <ol className="steps-container">
          {steps.map((step, index) => (
            <Reveal key={step.number} as="li" className="step-item" delay={index * 0.1}>
              <div className="step-number">
                <span>{step.number}</span>
                <span className="step-icon" aria-hidden="true">{step.icon}</span>
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
